// extracted by mini-css-extract-plugin
module.exports = {"Mechanisms":"Mechanism_Mechanisms__1Q-Ul","Mechanism":"Mechanism_Mechanism__3RsGA","swiper":"Mechanism_swiper__1NU8O"};